module.exports = __webpack_public_path__ + "static/media/204B-1204B.cddbf82c.png";